<template>
  <nav class="navbar navbar-expand-lg bg-light">
    <div class="container-lg">
      <a class="navbar-brand" href="#">Consultek</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse justify-content-md-center navbar-collapse" id="navbarNavAltMarkup">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" role="button" v-on:click="navScroll('sec_fp')">Farmácia Popular</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="button" v-on:click="navScroll('sec_sngpc')">SNGPC</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" role="button" v-on:click="navScroll('sec_links')">Links Úteis</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Conexão remota
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#">Ammyy</a></li>
              <li><a class="dropdown-item" href="#">Any desk</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Downloads</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  methods:{
    navScroll(el){
      var element = document.getElementById(el);

      if(element) {
        element.scrollIntoView();
      }
    }
  }
}
</script>

<style scoped>

</style>